// Customer fields that hold several lines (bug hunt 8 Oct 2026): a one-line box drops the line breaks, so opening a
// long note on the customer page or in Work's Full sheet and tapping away saved it with every line glued together.
// These edit in a box that keeps lines, as does any field whose value already has a line break in it.
const MULTILINE = new Set(['notes', 'job_notes', 'call_notes', 'said_note', 'parking_restrictions', 'preferred_times', 'cycle_text'])

export function multilineField(field: string, value: unknown): boolean {
  return MULTILINE.has(field) || (typeof value === 'string' && /[\r\n]/.test(value))
}

// Tall enough to show the lines it has, three to eight.
export function textareaRows(value: unknown): number {
  const lines = typeof value === 'string' ? value.split(/\r\n|\r|\n/).length : 1
  return Math.min(8, Math.max(3, lines))
}
